/**
 * Function `truncate` truncates the string and adds ellipsis if string is
 * longed than specified limit amount
 *
 * @function truncate
 * @param {String, Number} - String and limit
 * @returns {String} - returns truncated or original string
 */

/**
 * Function `truncate` truncates the string and adds ellipsis if string is
 * longed than specified limit amount
 * @param text - String
 * @param lim - limit
 * @returns {string} - returns truncated or original string
 */
const truncate = (text: string, lim: number): string =>
  text.length > lim ? `${text.substring(0, lim - 3)}…` : text;

export default truncate;
